import Section from '../../../components/Modular/Section';
import Unit from '../../../components/Modular/Unit';
import Assembly from '../../../components/Modular/Assembly';
import { NavLink } from 'react-router-dom';
import MicroUnit from '../../../components/Modular/MicroUnit';
import './AdminSidebar.css';

export function AdminSidebar() {
  interface AdminNavigationItem {
    label: string;
    path: string;
  }

  const navigationItems: AdminNavigationItem[] = [
    {
      label: 'Dashboard',
      path: '/',
    },
    {
      label: 'Consultations',
      path: '/consultations',
    },
    {
      label: 'Contracts',
      path: '/contracts',
    },
    {
      label: 'Work Sprints',
      path: '/work-sprints',
    },
    {
      label: 'Action Items',
      path: '/action-items',
    },
  ];

  return (
    <Section as="aside" paddingTop="xl" paddingLeft="lg" marginTop="2xl">
      <Assembly as="nav" layout="grid">
        {navigationItems.map((item) => (
          <Unit
            paddingTop="md"
            paddingBottom="md"
            paddingLeft="md"
            paddingRight="md"
            background="surface"
            borderRadius="sm"
            marginTop="sm"
            as="div"
            className="item"
          >
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) =>
                [
                  'admin-sidebar__link',
                  isActive && 'admin-sidebar__link--active',
                ]
                  .filter(Boolean)
                  .join(' ')
              }
            >
              <MicroUnit as="p" pColor="light">
                {item.label}
              </MicroUnit>
            </NavLink>
          </Unit>
        ))}
      </Assembly>
    </Section>
  );
}
